"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _theLoopsService = require("../../../services/theLoopsService");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var query = null;

var Autopilot = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Autopilot, _PureComponent);

  var _super = _createSuper(Autopilot);

  function Autopilot() {
    var _this;

    (0, _classCallCheck2.default)(this, Autopilot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupResizeHandling", function () {
      var container = document.getElementById('loops-ask-container');

      if (container) {
        _this.resizeIframe();

        window.addEventListener('resize', _this.resizeIframe);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeIframe", function () {
      var container = document.getElementById('loops-ask-container');

      if (container) {
        var containerRect = container.getBoundingClientRect();
        var occupiedSpace = containerRect.top;
        var height = window.innerHeight - occupiedSpace - 20;
        container.style.height = "".concat(height, "px");
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Autopilot, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)("div", {
        id: "loops-ask-container",
        style: this.props.parentHeight ? {
          height: this.props.parentHeight
        } : undefined
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _document$getElementB, _document$getElementB2;

      var urlParams = new URLSearchParams(window.location.search);
      query = urlParams.get('query');
      var shouldAdd = !query;
      var cssVariablesContent = (_document$getElementB = (_document$getElementB2 = document.getElementById('css-variables')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.textContent) !== null && _document$getElementB !== void 0 ? _document$getElementB : '';
      var userData = (0, _theLoopsService.getTheLoopsUserData)();

      var widgetConfig = _objectSpread(_objectSpread({}, this.props), {}, {
        shouldAdd: shouldAdd,
        cssVariablesContent: cssVariablesContent,
        userId: userData.userId,
        userEmail: userData.userEmail
      });

      initializeWidget(widgetConfig); // listen for the received widget events

      window.addEventListener('onLoopsMessageReceived', loopMessageReceived);
      setQueryOnLoopsWidgetFromUrl(); // Only setup resize handling if parentHeight is not provided

      if (!this.props.parentHeight) {
        this.setupResizeHandling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('onLoopsMessageReceived', loopMessageReceived);
      window.removeEventListener('resize', this.resizeIframe);
    }
  }]);
  return Autopilot;
}(_preactCompat.PureComponent);

exports.default = Autopilot;

function initializeWidget(widgetConfig) {
  var _window$widgets;

  window.widgets = (_window$widgets = window.widgets) !== null && _window$widgets !== void 0 ? _window$widgets : {};
  window.widgets.generateUserToken = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _widgetConfig$isFromC;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _theLoopsService.refreshTheLoopsToken)({
              widgetId: widgetConfig.widgetId,
              userId: widgetConfig.userId
            }, (_widgetConfig$isFromC = widgetConfig.isFromControl) !== null && _widgetConfig$isFromC !== void 0 ? _widgetConfig$isFromC : false));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  loopsGlobal.setLoopsAskWidgetConfig({
    tenantId: widgetConfig.tenantId,
    userId: widgetConfig.userId,
    userEmail: widgetConfig.userEmail,
    widgetId: widgetConfig.widgetId,
    widgetWidth: widgetConfig.widgetWidth,
    widgetHeight: widgetConfig.widgetHeight,
    widgetRenderingId: 'loops-ask-container',
    data: _objectSpread(_objectSpread({
      widgetType: 'ask-expanded'
    }, widgetConfig.shouldAdd && {
      defaultHomePage: 'vertical'
    }), {}, {
      styleSheets: ["".concat(widgetConfig.cdnPrefix).concat(widgetConfig.cdnPrefix.endsWith('/') ? '' : '/', "css/autopilot-widget.css")],
      styles: widgetConfig.cssVariablesContent + widgetConfig.customCss + "#root { height: 100% !important; } .tlw-widget-container.new-chat .ant-layout { background-color: white !important; }"
    })
  });
}

function setQueryOnLoopsWidgetFromUrl() {
  if (query) {
    loopsGlobal.ask(query);
  }
}

function loopMessageReceived(e) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(e.detail);
  }
}